module.exports = __webpack_public_path__ + "static/media/noul-smile-logo.110ab8f0.svg";